import getDates from './date.service'

const getMessagesData = (messages) => {
  let count = messages.count
  let data = messages.positions
  let tableData = []

  data.forEach((item, index) => {
    let lastItem = tableData[tableData.length - 1]
    let lastItemDate = !!lastItem ? getDates.getNullMinTimeDateUtcNumber(lastItem.startDate) : null
    let itemDate = getDates.getNullMinTimeDateUtcNumber(item.time)

    if (!!lastItem && lastItemDate === itemDate) {
      lastItem.finishDate = item.time
      lastItem.finishIndex = index
    } else {
      tableData.push({
        startIndex: index,
        startDate: item.time,
        data: item.data
      })
    }
  })

  tableData.map((item, index) => {
    return item.id = index
  })

  return {
    count,
    data,
    tableData
  }
}

export default getMessagesData